
import { Component, Vue } from 'vue-property-decorator';
import HeaderNav from '@/components/header-nav.vue';
import { BytedIconConfig } from '@byte-design/vue-icons';
import ReminderBanner from './components/reminder-banner.vue';
import NotificationList from './components/notification-list.vue';
import { State, Action } from 'vuex-class';
import { NotificationListReq, NotificationType } from '@/const/notification';
import { getUnreadList } from '@/service';

@Component({
  name: 'Notification',
  components: {
    HeaderNav,
    BytedIconConfig,
    ReminderBanner,
    NotificationList,
  },
})
export default class Notification extends Vue {
  @State((state: any) => state.notification.notificationList)
  readonly notificationList: [];

  @Action('notification/getBannerListSuggestions') getBannerListSuggestions: any;
  @Action('notification/getNotificationList') getNotificationList: (params: NotificationListReq) => Promise<{
    total: number;
    notification_data: any;
  }>;

  loading = false;
  list: any;
  unreadNum = 0;
  total = 0;

  params: NotificationListReq = {
    page: 1,
    limit: 10,
    notification_type: NotificationType.ALL,
    display_platform: 2,
    unite_status: 1,
  };

  created() {
    this.fetchNotificationList();
    this.getBannerListSuggestions();
    this.getUnreadList();
  }

  onBack() {
    this.$router.back();
  }

  async getUnreadList() {
    try {
      const info = await getUnreadList();
      this.unreadNum = (info?.data?.unread_data || []).reduce((total: number, i) => total + i.total, 0);
    } catch (error) {
      console.log(error);
    }
  }

  async fetchNotificationList() {
    try {
      const info = await this.getNotificationList(this.params);
      this.total = info.total;
    } catch (error) {
      console.log(error);
    }
  }

  async pullUp() {
    this.params.page++;
    await this.fetchNotificationList();
    this.loading = false;
  }

  async pullDown() {
    this.params.page = 1;
    this.getUnreadList();
    await this.fetchNotificationList();
    this.loading = false;
  }

  goToManager() {
    this.$router.push({ name: 'notification-manager' });
  }

  onSelect(item: { label: string; value: NotificationType }) {
    this.params.notification_type = item.value;
    this.params.page = 1;
    this.fetchNotificationList();
  }
}
